import { render } from "./AppSideNav.vue?vue&type=template&id=96887200&scoped=true"
import script from "./AppSideNav.vue?vue&type=script&lang=js"
export * from "./AppSideNav.vue?vue&type=script&lang=js"

import "./AppSideNav.vue?vue&type=style&index=0&id=96887200&scoped=true&lang=css"
script.render = render
script.__scopeId = "data-v-96887200"

export default script